export default ({ request }) => ({
  dfInspectionWorkshopListApi(data = {}) {
    return request({
      url: '/dfs/df/inspection/workshop/list',
      method: 'post',
      data,
    })
  },
  dfInspectionWorkshopSaveApi(data = {}) {
    return request({
      url: '/dfs/df/inspection/workshop/save',
      method: 'post',
      data,
    })
  },
  dfInspectionWorkshopDelApi(data = {}) {
    return request({
      url: '/dfs/df/inspection/workshop/del',
      method: 'post',
      data,
    })
  },
})

